import { render, staticRenderFns } from "./ProjectStatisticsIndex.vue?vue&type=template&id=41689abe&scoped=true&"
import script from "./ProjectStatisticsIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectStatisticsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41689abe",
  null
  
)

export default component.exports